export default "__VITE_ASSET__BmBs92bT__"